import { GraphQLClient, gql } from 'graphql-request';

import { getAssetFromAddress } from '~config/protocol';
import { NetworkIds } from '~config/rpcConfig';
import { AllVestaAssets, ENativeAsset } from '~config/types';

export default class GlobalAccruedFees {
  constructor(private readonly client: GraphQLClient, private readonly networkId: NetworkIds) {}

  async getAccruedFees(block: number) {
    const feesQuery = gql`
      query get_asset_stats_fees($block: Int) {
        assetStats(first: 1000, block: { number: $block }) {
          asset {
            id
          }
          totalBorrowingFeesPaid
          totalRedemptionFeesPaid
        }
      }
    `;
    const feeResult: {
      assetStats: {
        asset: { id: string };
        totalBorrowingFeesPaid: string;
        totalRedemptionFeesPaid: string;
      }[];
    } = await this.client.request(feesQuery, { block });

    return feeResult.assetStats.reduce(
      (acc, { asset: { id }, totalBorrowingFeesPaid, totalRedemptionFeesPaid }) => {
        acc[ENativeAsset.VST] = (Number(acc[ENativeAsset.VST]) + Number(totalBorrowingFeesPaid)).toString();
        acc[getAssetFromAddress(id, this.networkId)] = totalRedemptionFeesPaid;

        return acc;
      },
      {
        [ENativeAsset.VST]: '0',
      } as Record<Partial<AllVestaAssets>, string>,
    );
  }
}
